export default __webpack_public_path__ + "static/media/hbs-bpk-4.c5ef0c46.png";